import SiteNavbar from "@/components/feature/SiteNavbar";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import Hero from "./components/Hero";
import ProcessSection from "./components/ProcessSection";
import StandardsSection from "./components/StandardsSection";
import RulesSection from "./components/RulesSection";
import TimelineSection from "./components/TimelineSection";
import CategoriesSection from "./components/CategoriesSection";
import FaqSection from "./components/FaqSection";
import BrandSection from "./components/BrandSection";
import ContactSection from "./components/ContactSection";
import {
  websiteSchema,
  organizationSchema,
  webPageSchema,
  faqSchema,
} from "./structuredData";

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <SiteNavbar />

      <main className="w-full">
        <Hero />
        <ProcessSection />
        <StandardsSection />
        <RulesSection />
        <TimelineSection />
        <CategoriesSection />
        <FaqSection />
        <BrandSection />
        <ContactSection />
      </main>

      <SiteFooter />
      <BackToTop />
    </>
  );
}